import styled from 'styled-components'
import config from '../../config'

export const RegisterContainer = styled.div`
  position: relative;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
`

export const NavBarContainer = styled.div`
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  padding-bottom: 2%;
  .rdsbottom{
    border-bottom-left-radius: 40px;
  }
  z-index: 2;
`

export const TelephoneServiceContainer = styled.div`
  height: auto;
  display: flex;
  padding-left: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
`

export const IconContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`

export const TelephoneTextContainer = styled.div`
  font-family: 'YouYuan';
  font-size: 1rem;
  color: ${config.theme.textColor};
  flex: 5;
`
export const ContainerMiddle = styled.div`
  background-color: white;
  width: 90%;
  z-index: 1;
  position: absolute;
  top: 0;
  left: 5%;
  color: #565656;
  font-family: 'YouYuan';
  display: flex;
  flex-direction: column;
  -webkit-overflow-scrolling: touch;
`
export const ContainerMiddleContent = styled.div`
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 25%;
`
export const ContainerMiddleList = styled.div`
  width: 100%;
  margin-top: 5%;
`
export const ContainerBottomContent = styled.div`
  width: 90%;
  margin-top: 0%;
  margin-left: 5%;
  margin-right: 5%;
  padding-top: 10%;
`

export const BottomTitle = styled.div`
  width: 100%;
  font-size: 1.125rem;
  margin-bottom: 5%;
  font-weight: bold;
`
export const RegisterButtonsContainer = styled.div`
width: 100%;
margin-top: 20px;
margin-bottom: 40px;
border: 0px;
`
export const ButtonSubmit = styled.button`
  width: 35%;
  background: linear-gradient(to right, #63D5ED, #6E8FF8);
  color:white;
  border-radius:15px;
  border: 0px;
  font-size:1rem;
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
  margin-left: 32.5%;
  margin-right: auto;
`

export const DeleteIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
`

export const NumberConfirmButton = styled.div`
  border: 1px solid #1199FE;
  font-size: 0.8rem;
  border-radius: 30px;
  color: #1199FE;
  height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  line-height: 90%;
`
